export default __webpack_public_path__ + "static/media/nope-4.96c34774.gif";